import { render, staticRenderFns } from "./RestaurantsEdit.vue?vue&type=template&id=e40e4cb8&"
import script from "./RestaurantsEdit.vue?vue&type=script&lang=js&"
export * from "./RestaurantsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports